import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Button, { BUTTON_HEIGHT_20 } from '../../../../Button'
import Text from '../../../../Text'
import { CalendarGridDayNumber } from '../../../CalendarGridDayNumber'
import { CalendarGridDayPopoverTrigger } from '../../../CalendarGridDayPopoverTrigger'
import { getIsCalendarGridTodayTinted } from '../../CalendarGridWeek.utils'

import { QA_NAME_CALENDAR_GRID_OUTSIDE_HOURS } from './CalendarGridWeekHeadCell.constants'

import * as styles from './CalendarGridWeekHeadCell.module.css'

function CalendarGridWeekHeadCell({
  className = styles.CalendarGridWeekHeadCell,
  day,
  dayItems,
  dayLoad,
  days,
  outsideHoursItems,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { t } = useTranslation()

  return (
    <div
      className={classNames(className, {
        [styles.today]: getIsCalendarGridTodayTinted({ day, days, today }),
      })}
    >
      <Text isSecondary>{day.weekdayLabel}</Text>
      <CalendarGridDayPopoverTrigger
        Trigger={CalendarGridDayNumber}
        day={day.date}
        dayLoad={dayLoad}
        items={dayItems}
        triggerProps={{ children: day.dayLabel }}
        onClickItem={onClickItem}
        onClickSecondaryLabel={onClickSecondaryLabel}
      />
      {outsideHoursItems ? (
        <CalendarGridDayPopoverTrigger
          Trigger={Button.Flat}
          day={day.date}
          items={outsideHoursItems}
          triggerProps={{
            className: styles.outsideHours,
            height: BUTTON_HEIGHT_20,
            qaName: QA_NAME_CALENDAR_GRID_OUTSIDE_HOURS,
            text: t('Calendar.OutsideHoursKey', {
              count: outsideHoursItems.length,
            }),
          }}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ) : null}
    </div>
  )
}

export default CalendarGridWeekHeadCell
